// extracted by mini-css-extract-plugin
export default {"container":"Language_container__bdVl-","label":"Language_label__OSnOp","code":"Language_code__pOa9v"};